// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container{ 
    width:100%;margin:auto;
    cursor: initial;
    height: 100%;
    padding-right: 0px;
    padding-left: 0px;
  /* cursor: pointer; */
  }
  /* .container *{ 
  
  cursor: pointer !important;
  } */
  dcontainer{
    cursor:initial !important;
  }

.inbox_people {
  background: #f8f8f8 none repeat scroll 0 0;
  float: left;
  overflow: hidden;
  width: 40%; border-right:1px solid #c4c4c4;
}
.inbox_msg {
  border: 1px solid #c4c4c4;
  clear: both;
  overflow: hidden;
}
.top_spac{ margin: 20px 0 0;}


.recent_heading {float: left; width:40%;}
.srch_bar {
  display: inline-block;
  text-align: right;
  width: 60%; 
}
.headind_srch{ padding:10px 29px 10px 20px; overflow:hidden; border-bottom:1px solid #c4c4c4;}

.recent_heading h4 {
  color: #05728f;
  font-size: 21px;
  margin: auto;
}
.srch_bar input{ border:1px solid #cdcdcd; border-width:0 0 1px 0; width:80%; padding:2px 0 4px 6px; background:none;}
.srch_bar .input-group-addon button {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  padding: 0;
  color: #707070;
  font-size: 18px;
}
.srch_bar .input-group-addon { margin: 0 0 0 -27px;}

.chat_ib h5{ font-size:15px; color:#464646; margin:0 0 8px 0;}
.chat_ib h5 span{ font-size:13px; float:right;}
.chat_ib p{ font-size:14px; color:#989898; margin:auto}
.chat_img {
  float: left;
  width: 11%;
}
.chat_ib {
  float: left;
  padding: 0 0 0 15px;
  width: 88%;
}

.chat_people{ overflow:hidden; clear:both;}
.chat_list {
  border-bottom: 1px solid #c4c4c4;
  margin: 0;
  padding: 18px 16px 10px;
}
.inbox_chat { height: 550px; overflow-y: scroll;}

.active_chat{ background:#ebebeb;}

.incoming_msg_img {
  display: inline-block;
  width: 6%;
}
.received_msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 95%;
 }
 .received_withd_msg p {
  background: #ebebeb none repeat scroll 0 0;
  border-radius: 3px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;
}
.time_date {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
  float:right;
}
.received_withd_msg { width: 100%;}
.mesgs {
  float: left;
  
  width: 100%;
  min-height: 300px;
}

 .sent_msg p {
  background: #05728f none repeat scroll 0 0;
  border-radius: 3px;
  font-size: 14px;
  margin: 0; color:#fff;
  padding: 5px 10px 5px 12px;
  width:100%;
}
.outgoing_msg{ overflow:hidden; margin:26px 0 26px;}
.sent_msg {
  float: right;
  width: 46%;
}
.input_msg_write input {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border-top: 1px solid #CCC;
  color: #4c4c4c;
  font-size: 15px;
  left: 10%;
  min-height: 35px;
  width: 63%;
}

.type_msg {position: absolute;top:308px;width: 100%;}
.msg_send_btn {
  background: #165788 none repeat scroll 0 0;
  border: medium none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  height: 33px;
  float: right;
  margin-top:5px;
  /* position: absolute; */
  /* right: 0; */
  /* top: 11px; */
  width: 15%;
  position: absolute;
  left:-20px;
}
.messaging { padding: 0 0 50px 0;}
.msg-history {
  max-height: 300px;
    overflow-y: auto;
}
.write_msg
{
    opacity: 1;
    

}
.clsUsername
{
    font-size: 13px;
    font-weight: bold;
    
    color:rgb(5, 74, 112);
}
.clsHeading
{
    font-weight: bold;
    background-color: rgb(5, 74, 112);
    padding: 10px;
    width: 100%;
    margin-left: 0px;
    color:white;
    border-radius: 5px 5px 0px 0px !important;
    position: relative;
    top:-5px;
}
.mesgs
{
    position: relative;
}

`, "",{"version":3,"sources":["webpack://./src/app/comment-box/comment-box.component.css"],"names":[],"mappings":"AAAA;IACI,UAAU,CAAC,WAAW;IACtB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB,qBAAqB;EACrB;EACA;;;KAGG;EACH;IACE,yBAAyB;EAC3B;;AAEF;EACE,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,UAAU,EAAE,8BAA8B;AAC5C;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA,WAAW,gBAAgB,CAAC;;;AAG5B,iBAAiB,WAAW,EAAE,SAAS,CAAC;AACxC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;AACZ;AACA,eAAe,2BAA2B,EAAE,eAAe,EAAE,+BAA+B,CAAC;;AAE7F;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA,iBAAiB,wBAAwB,EAAE,sBAAsB,EAAE,SAAS,EAAE,qBAAqB,EAAE,eAAe,CAAC;AACrH;EACE,mDAAmD;EACnD,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA,+BAA+B,mBAAmB,CAAC;;AAEnD,aAAa,cAAc,EAAE,aAAa,EAAE,gBAAgB,CAAC;AAC7D,kBAAkB,cAAc,EAAE,WAAW,CAAC;AAC9C,YAAY,cAAc,EAAE,aAAa,EAAE,WAAW;AACtD;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA,cAAc,eAAe,EAAE,UAAU,CAAC;AAC1C;EACE,gCAAgC;EAChC,SAAS;EACT,uBAAuB;AACzB;AACA,cAAc,aAAa,EAAE,kBAAkB,CAAC;;AAEhD,cAAc,kBAAkB,CAAC;;AAEjC;EACE,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;CACX;CACA;EACC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA,sBAAsB,WAAW,CAAC;AAClC;EACE,WAAW;;EAEX,WAAW;EACX,iBAAiB;AACnB;;CAEC;EACC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,SAAS,EAAE,UAAU;EACrB,0BAA0B;EAC1B,UAAU;AACZ;AACA,eAAe,eAAe,EAAE,kBAAkB,CAAC;AACnD;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,mDAAmD;EACnD,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA,WAAW,kBAAkB,CAAC,SAAS,CAAC,WAAW,CAAC;AACpD;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;AACA,aAAa,mBAAmB,CAAC;AACjC;EACE,iBAAiB;IACf,gBAAgB;AACpB;AACA;;IAEI,UAAU;;;AAGd;AACA;;IAEI,eAAe;IACf,iBAAiB;;IAEjB,qBAAqB;AACzB;AACA;;IAEI,iBAAiB;IACjB,iCAAiC;IACjC,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,yCAAyC;IACzC,kBAAkB;IAClB,QAAQ;AACZ;AACA;;IAEI,kBAAkB;AACtB","sourcesContent":[".container{ \r\n    width:100%;margin:auto;\r\n    cursor: initial;\r\n    height: 100%;\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n  /* cursor: pointer; */\r\n  }\r\n  /* .container *{ \r\n  \r\n  cursor: pointer !important;\r\n  } */\r\n  dcontainer{\r\n    cursor:initial !important;\r\n  }\r\n\r\n.inbox_people {\r\n  background: #f8f8f8 none repeat scroll 0 0;\r\n  float: left;\r\n  overflow: hidden;\r\n  width: 40%; border-right:1px solid #c4c4c4;\r\n}\r\n.inbox_msg {\r\n  border: 1px solid #c4c4c4;\r\n  clear: both;\r\n  overflow: hidden;\r\n}\r\n.top_spac{ margin: 20px 0 0;}\r\n\r\n\r\n.recent_heading {float: left; width:40%;}\r\n.srch_bar {\r\n  display: inline-block;\r\n  text-align: right;\r\n  width: 60%; \r\n}\r\n.headind_srch{ padding:10px 29px 10px 20px; overflow:hidden; border-bottom:1px solid #c4c4c4;}\r\n\r\n.recent_heading h4 {\r\n  color: #05728f;\r\n  font-size: 21px;\r\n  margin: auto;\r\n}\r\n.srch_bar input{ border:1px solid #cdcdcd; border-width:0 0 1px 0; width:80%; padding:2px 0 4px 6px; background:none;}\r\n.srch_bar .input-group-addon button {\r\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\r\n  border: medium none;\r\n  padding: 0;\r\n  color: #707070;\r\n  font-size: 18px;\r\n}\r\n.srch_bar .input-group-addon { margin: 0 0 0 -27px;}\r\n\r\n.chat_ib h5{ font-size:15px; color:#464646; margin:0 0 8px 0;}\r\n.chat_ib h5 span{ font-size:13px; float:right;}\r\n.chat_ib p{ font-size:14px; color:#989898; margin:auto}\r\n.chat_img {\r\n  float: left;\r\n  width: 11%;\r\n}\r\n.chat_ib {\r\n  float: left;\r\n  padding: 0 0 0 15px;\r\n  width: 88%;\r\n}\r\n\r\n.chat_people{ overflow:hidden; clear:both;}\r\n.chat_list {\r\n  border-bottom: 1px solid #c4c4c4;\r\n  margin: 0;\r\n  padding: 18px 16px 10px;\r\n}\r\n.inbox_chat { height: 550px; overflow-y: scroll;}\r\n\r\n.active_chat{ background:#ebebeb;}\r\n\r\n.incoming_msg_img {\r\n  display: inline-block;\r\n  width: 6%;\r\n}\r\n.received_msg {\r\n  display: inline-block;\r\n  padding: 0 0 0 10px;\r\n  vertical-align: top;\r\n  width: 95%;\r\n }\r\n .received_withd_msg p {\r\n  background: #ebebeb none repeat scroll 0 0;\r\n  border-radius: 3px;\r\n  color: #646464;\r\n  font-size: 14px;\r\n  margin: 0;\r\n  padding: 5px 10px 5px 12px;\r\n  width: 100%;\r\n}\r\n.time_date {\r\n  color: #747474;\r\n  display: block;\r\n  font-size: 12px;\r\n  margin: 8px 0 0;\r\n  float:right;\r\n}\r\n.received_withd_msg { width: 100%;}\r\n.mesgs {\r\n  float: left;\r\n  \r\n  width: 100%;\r\n  min-height: 300px;\r\n}\r\n\r\n .sent_msg p {\r\n  background: #05728f none repeat scroll 0 0;\r\n  border-radius: 3px;\r\n  font-size: 14px;\r\n  margin: 0; color:#fff;\r\n  padding: 5px 10px 5px 12px;\r\n  width:100%;\r\n}\r\n.outgoing_msg{ overflow:hidden; margin:26px 0 26px;}\r\n.sent_msg {\r\n  float: right;\r\n  width: 46%;\r\n}\r\n.input_msg_write input {\r\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\r\n  border-top: 1px solid #CCC;\r\n  color: #4c4c4c;\r\n  font-size: 15px;\r\n  left: 10%;\r\n  min-height: 35px;\r\n  width: 63%;\r\n}\r\n\r\n.type_msg {position: absolute;top:308px;width: 100%;}\r\n.msg_send_btn {\r\n  background: #165788 none repeat scroll 0 0;\r\n  border: medium none;\r\n  border-radius: 50%;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  font-size: 17px;\r\n  height: 33px;\r\n  float: right;\r\n  margin-top:5px;\r\n  /* position: absolute; */\r\n  /* right: 0; */\r\n  /* top: 11px; */\r\n  width: 15%;\r\n  position: absolute;\r\n  left:-20px;\r\n}\r\n.messaging { padding: 0 0 50px 0;}\r\n.msg-history {\r\n  max-height: 300px;\r\n    overflow-y: auto;\r\n}\r\n.write_msg\r\n{\r\n    opacity: 1;\r\n    \r\n\r\n}\r\n.clsUsername\r\n{\r\n    font-size: 13px;\r\n    font-weight: bold;\r\n    \r\n    color:rgb(5, 74, 112);\r\n}\r\n.clsHeading\r\n{\r\n    font-weight: bold;\r\n    background-color: rgb(5, 74, 112);\r\n    padding: 10px;\r\n    width: 100%;\r\n    margin-left: 0px;\r\n    color:white;\r\n    border-radius: 5px 5px 0px 0px !important;\r\n    position: relative;\r\n    top:-5px;\r\n}\r\n.mesgs\r\n{\r\n    position: relative;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
